module.exports = __webpack_public_path__ + "static/media/bolshoi-logo-big.ca0252c3.gif";